import { CreateDonationRequestCurrencyEnum } from '@/app/api';
import { getCountryConfig } from '@/app/utils/countryConfig';

const countryConfig = getCountryConfig();

export const getCurrency = (): CreateDonationRequestCurrencyEnum => {
  const currency = countryConfig.currency;

  if (!currency) {
    throw new Error('No currency is set in country config');
  }

  if (!(Object.values(CreateDonationRequestCurrencyEnum) as string[]).includes(currency)) {
    throw new Error(
      `Invalid currency provided in countryConfig. Valid options are: ${Object.values(CreateDonationRequestCurrencyEnum).join(',')}`,
    );
  }

  return currency as CreateDonationRequestCurrencyEnum;
};
